export default __webpack_public_path__ + "static/media/36.920c4dda.jpg";